export default __webpack_public_path__ + "static/media/Tennis_07.3cd9f55a.png";